const applicationRouters = [
  // 应用接入
  {
    path: 'application',
    name: 'application',
    redirect: '/manage/system/application/list',
    component: () => import(/* webpackChunkName: "application" */ '@/views/content'),
    meta: {
      sidebar: 2,
      // 可查看用户列表的权限
      authKey: ['auth_application'],
      title: 'application_menu',
      disabled: false,
      icon: 'menu_application',
    },
    children: [
      // 用户管理 - 列表
      {
        path: 'list',
        name: 'ApplicationList',
        component: () =>
          import(/* webpackChunkName: "ApplicationList" */ '@/views/application/list'),
        meta: {
          sidebar: false,
          authKey: ['auth_application', 'auth_application_list'],
          breadcrumb: false,
          title: 'application_menu',
          disabled: false,
          icon: 'menu_application',
        },
      },
      // 创建应用
      {
        path: 'add',
        name: 'ApplicationAdd',
        component: () =>
          import(/* webpackChunkName: "ApplicationAdd" */ '@/views/application/update'),
        meta: {
          sidebar: false,
          authKey: ['auth_application', 'auth_application_add'],
          title: 'application_menu_add',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },
      // 更新应用
      {
        path: 'update/:id',
        name: 'ApplicationUpdate',
        component: () =>
          import(/* webpackChunkName: "ApplicationUpdate" */ '@/views/application/update'),
        meta: {
          sidebar: false,
          authKey: ['auth_application', 'auth_application_edit'],
          title: 'application_menu_edit',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },
      // 应用详情
      {
        path: 'detail/:id',
        name: 'ApplicationDetail',
        component: () =>
          import(/* webpackChunkName: "ApplicationDetail" */ '@/views/application/detail'),
        meta: {
          sidebar: false,
          authKey: ['auth_application', 'auth_application_detail'],
          title: 'application_menu_detail',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },
    ],
  },
];

export default applicationRouters;
